// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\ValueObject.tt
// </auto-generated>
// ------------------------------------------------------------------------------
/**
 * 两个值的结构 实体类
 * 两个浮点型值的结构，可用于表示一个点，或者长宽
 */
export class Double2D {
  x: number;
  y: number;

  constructor(x = 0, y = 0) {
    this.x = x;
    this.y = y;
  }
}
